// apps/web/src/routes/Landing.tsx
//
// /  — public landing. Lists the value prop, links to /signin and
// /signup, links to the /@handle example, and (if authenticated) to
// /dashboard.

import { Link } from 'react-router-dom';
import { useMeOrNull } from '../lib/auth.js';
import { Button } from '../components/ui/Button.js';

export function Landing(): JSX.Element {
  const me = useMeOrNull();
  return (
    <section className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100">
        BUMBUM
      </h1>
      <p className="mt-3 text-lg text-gray-700 dark:text-gray-300">
        A small, passwordless, sign-in-by-OTP user-management webapp.
      </p>
      <ul className="mt-6 space-y-2 text-sm text-gray-700 dark:text-gray-300">
        <li>• Sign in with your phone or email — no password to remember.</li>
        <li>• Public @handle profile pages.</li>
        <li>• Two-step avatar upload with built-in square crop.</li>
        <li>• Active-session list with per-device revoke.</li>
      </ul>

      <div className="mt-8 flex flex-wrap items-center gap-3">
        {me ? (
          <>
            <Link to="/dashboard">
              <Button variant="primary">Open dashboard</Button>
            </Link>
            <Link to={`/@${me.handle}`} className="text-sm text-brand-600 hover:underline dark:text-brand-400">
              View your public profile
            </Link>
          </>
        ) : (
          <>
            <Link to="/signin"><Button variant="primary">Sign in</Button></Link>
            <Link to="/signup"><Button variant="secondary">Create account</Button></Link>
            <Link to="/@bumbum" className="text-sm text-gray-500 hover:underline dark:text-gray-400">
              See an example profile
            </Link>
          </>
        )}
      </div>
    </section>
  );
}
